import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import pkg from '../package.json';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

if (
  process.env.REACT_APP_SENTRY_DSN !== undefined &&
  window.location.host !== 'localhost'
) {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, release: pkg.version });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
